import Vue from 'vue';
import Vuetify from 'vuetify';
import { deleteCookie, getCookie } from '../helpers/cookie';

Vue.use(Vuetify);

// const cspNonce = getCookie('sn');
// deleteCookie('sn');

// tslint:disable-next-line
// console.log(`SN=${cspNonce}`);

export default new Vuetify({
  rtl: false,
  theme: {
    options: { cspNonce: 'aZb7j31PeYzL' },
    dark: false,
    themes: {
      dark: {
        primary: '#016EA1',
        accent: '#016EA1',
        secondary: '#ED8D28',
        success: '#4CAF50',
        info: '#016EA1',
        warning: '#FB8C00',
        error: '#D10000',
      },
      light: {
        primary: '#016EA1',
        accent: '#016EA1',
        secondary: '#ED8D28',
        success: '#4CAF50',
        info: '#016EA1',
        warning: '#FB8C00',
        error: '#D10000',
      },
    },
  },
});
